var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "trial-end-clock",
        {
          attrs: {
            title: _vm.$t.__("common.labels.account_is_now_inactive"),
            subtitles: [
              _vm.$t.__("common.labels.subscription_expired"),
              _vm.$t.__(
                "pages.errors.BasicCartExpired.to_continue_choose_offer"
              )
            ]
          }
        },
        [
          _c(
            "a",
            {
              staticClass:
                "primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold",
              attrs: { href: "javascript:;", onclick: "MySupport.getForm()" }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Contacter un commercial")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "fs-4 lh-24 semibold mt-4",
            domProps: { innerHTML: _vm._s(_vm.tchat) }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }